// This file is generated by scripts/generateMapPins.js. Do not edit by hand.
// Run `yarn generate:map-pins` to regenerate.
//
// merchant_logo values we have artwork for. Unknown values fall back to the
// generic atm asset so we don't 404 on merchants the locations API adds that
// we haven't shipped art for yet.

// Sourced from public/map/pins/ at build time.
export const SUPPORTED_PIN_LOGOS: ReadonlySet<string> = new Set([
  'ampm',
  'atm',
  'cashback',
  'chevron',
  'circlek',
  'cvs',
  'duanereade',
  'dunkin',
  'harristeeter',
  'kroger',
  'mcdonalds',
  'racetrac',
  'riteaid',
  'safeway',
  'seveneleven',
  'speedway',
  'target',
  'walgreens',
  'wawa',
  'winndixie',
]);

// Sourced from public/map/icons/ at build time.
export const SUPPORTED_ICON_LOGOS: ReadonlySet<string> = new Set([
  'acecashexpress',
  'albertsons',
  'aldi',
  'ampm',
  'atm',
  'bedbathandbeyond',
  'caseys',
  'chevron',
  'circlek',
  'cumberlandfarms',
  'cvs',
  'dollargeneral',
  'dollartree',
  'duanereade',
  'dunkin',
  'familydollar',
  'foodlion',
  'gianteagle',
  'harristeeter',
  'heb',
  'holidaystation',
  'kroger',
  'kumandgo',
  'kwiktrip',
  'loves',
  'mcdonalds',
  'meijer',
  'officedepot',
  'pigglywiggly',
  'pilottravelcenters',
  'publix',
  'racetrac',
  'riteaid',
  'royalfarms',
  'safeway',
  'seveneleven',
  'sheetz',
  'speedway',
  'sprout',
  'staples',
  'stopandshop',
  'sunoco',
  'tapetro',
  'target',
  'thehomedepot',
  'traderjoes',
  'walgreens',
  'walmart',
  'wawa',
  'wholefoods',
  'winndixie',
]);
